<template>
<div class="chapter">
<div class="inner_page">
<a id="page_2"></a>
<div class="fm">
<p class="fm">All of the characters, situations, institutions, and animals in this book are products of the author’s fevered imagination and consequently fictional. Any resemblance to anyone or anything living or dead is pure coincidence, and most unfortunate.</p>
<p class="fmr">B. H. K.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Fm01.vue?bdc9520a